import HeaderSection from "../../../components/Header/HeaderSection"
import CardTransparent from "../../../components/CockpitCards/CardTransparent"


export default function VaccsText() {

    
    return (

     <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Your immunisation history" 
            headline_grey = "in one secure place -"
            headline_p2 = "vaccinations and cards"

            text1 = "Medical records hold important, sensitive information about you — including diseases, injuries, vaccinations, care history and more."
            text2 = "It is paramount to keep your medical records and data protected, but at the same time available for you and your doctors - in one place."

            />
    }/>
            
  )
}